import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import { updateWS } from 'Screens/Contextualization/Workspaces/actions/Actions';
import MarkdownEditor from 'Common/Components/v2/MarkdownEditor';
import ExpandableWrapper from 'Screens/Contextualization/Manage/components/VulnerabilityDetail/components/Tabs/components/GeneralTab/components/ExpandableWrapper';
import useExpandable from 'Hooks/useExpandable';
import { selectWsDetail } from 'store/Workspace/selectors';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_WORKSPACES, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const ID = 'customer';

const Customer = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const currentWs = useSelector(selectWsDetail);
  const customer = get(currentWs, ID, '');
  const canUpdate = useSelector((state) => selectAllowedByRole(state, FEATURE_WORKSPACES, PERMISSION_TYPES.UPDATE));
  const disabled = !canUpdate;
  const isExpanded = useExpandable('general', ID, customer, currentWs?.id);

  return (
    <ExpandableWrapper defaultValue={ isExpanded } title={ intl.formatMessage({ id: 'workspace.wsDetail.customer' }) } tab="general" id={ ID }>
      <MarkdownEditor
        value={ customer }
        onBlur={ (value) => dispatch(updateWS(currentWs.name, { customer: value })) }
        disabled={ disabled }
        minHeight={ 57 }
      />
    </ExpandableWrapper>
  );
};

export default Customer;
